import useAuthLink from './useAuthLink';

const AuthLink: React.FunctionComponent = function () {
  useAuthLink();
  return <div />;
};

export default AuthLink;
